import './chunk-455cdeae.js';
import './helpers.js';
import './chunk-e92e3389.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { I as Image } from './chunk-493ff0a9.js';
export { I as BImage } from './chunk-493ff0a9.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Image);
  }
};
use(Plugin);

export default Plugin;
